import { ClientsDashboard } from "@/features/clients";
import { verifyRoles } from "@/utils/verifyRoles";
import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { z } from "zod/v4";
import { isomorphicHttpClient } from "../../../httpClient";

const clientsFiltersSearchParamsSchema = z.object({
  tenantId: z.string().default("").catch(""),
  clientName: z.string().default("").catch(""),
  organizationName: z.string().default("").catch(""),
});

export const Route = createFileRoute("/dashboard/clients/")({
  component: ClientsDashboard,
  head: () => ({
    meta: [{ title: "Clientes - Backoffice Detentora Iniciador" }],
  }),
  validateSearch: clientsFiltersSearchParamsSchema,
  search: {
    middlewares: [
      stripSearchParams(clientsFiltersSearchParamsSchema.parse({})),
    ],
  },
  beforeLoad: () => verifyRoles(["INIC_ADMIN", "ORG_ADMIN", "ORG_OPERATOR"]),
  loader: async ({ context }) => {
    await context.queryClient.prefetchQuery({
      queryKey: ["tenants"],
      queryFn: async () => {
        const httpClient = isomorphicHttpClient();

        const { data, error } = await httpClient.GET("/v1/tenants");

        if (error) {
          throw new Error(error.message);
        }

        return data;
      },
    });
  },
});
